import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

// Tabs
import FlightReportRefuelApprovalsTab from './Elements/FlightReportRefuelApprovalsTab';
import FlightReportRefuelEditTab from './Elements/FlightReportRefuelEditTab';

class FlightReportRefuelsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      flight_report_refuel_edit: {},
      flight_report_legs_select: [],
      fuel_suppliers_select: [],
      aircrafts_select: [],
      locations_select: [],
      fuel_types_select: [],
      companies_select: [],
      staff_select: [],
      flight_report_refuel_approvals: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();

    this.updateData = this.updateData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  updateData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/abastecimento/'+ self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/bases');
        if (responseJson.status === 'success') {
            self.setState({
                flight_report_refuel_edit: responseJson.data.main,
                flight_report_legs_select: responseJson.data.flight_report_legs_select,
                fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
                aircrafts_select: responseJson.data.aircrafts_select,
                locations_select: responseJson.data.locations_select,
                fuel_types_select: responseJson.data.fuel_types_select,
                companies_select: responseJson.data.companies_select,
                staff_select: responseJson.data.staff_select,
                flight_report_refuel_approvals: responseJson.data.flight_report_refuel_approvals
            });
        }
      }).then(() => {
        self.handleMessage();
      }); /* Overlay */
    });
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/abastecimento/'+ self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/bases');
        if (responseJson.status === 'success') {
            self.setState({
                flight_report_refuel_edit: responseJson.data.main,
                flight_report_legs_select: responseJson.data.flight_report_legs_select,
                fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
                aircrafts_select: responseJson.data.aircrafts_select,
                locations_select: responseJson.data.locations_select,
                fuel_types_select: responseJson.data.fuel_types_select,
                companies_select: responseJson.data.companies_select,
                staff_select: responseJson.data.staff_select,
                flight_report_refuel_approvals: responseJson.data.flight_report_refuel_approvals
            });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  export() {
    var self = this;
    var url = "/relatorio/voo/abastecimento/caribbean/exportar/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.handleAlert('', '', 'closed');
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.titulo}</h3>
        <div className="grid-buttons pull-right">
          <Link to="/abastecimentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
        </div>
        <div className="clearfix"></div>
        {/* <hr/>
        <FlightReportRefuelApprovalsTab updateData={this.updateData} handleAlert={this.handleAlert} flight_report_refuel_edit={this.state.flight_report_refuel_edit}  flight_report_refuel_approvals={this.state.flight_report_refuel_approvals}/> */}
        <hr/>
        <FlightReportRefuelEditTab updateData={this.updateData} handleAlert={this.handleAlert} flight_report_refuel_edit={this.state.flight_report_refuel_edit}  flight_report_legs_select={this.state.flight_report_legs_select} fuel_suppliers_select={this.state.fuel_suppliers_select} aircrafts_select={this.state.aircrafts_select} locations_select={this.state.locations_select} fuel_types_select={this.state.fuel_types_select} companies_select={this.state.companies_select} staff_select={this.state.staff_select}/>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportRefuelsEdit;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/FlightReportRefuelsEdit.js